export const GET_CMS_BANNER = "GET_CMS_BANNER";